// mui
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: "20px",
    paddingRight: "20px",
    paddingTop: "20px",
    width: "300px",
    boxShadow: 4,
    fontSize: "1rem",
    backgroundColor: "white",
    position: "relative",
    top: "0px",

    "&:hover": {
      top: "-2.5px",
      boxShadow: "0px 4px 8px rgba(38, 38, 38, 0.2)",
    },
  },
  dataKey: {
    fontSize: "initial",
  },
  dataValue: {
    fontSize: 14,
  },
  chart: {
    padding : "0px 4px",

  },
  graphChart:{
    marginTop : '10px',
    display : 'grid',
    justifyContent: 'center',
    alignContent : 'center'
  },
  headerFont: {
    fontSize: 17,
    fontWeight: "bold",
  },
  noGraphData: {
    textAlign: "center",
    color: "grey",
    paddingTop: "80px",
    height : '210px'
  },
}));

export default useStyles;
